<div class="wrapper">
  <div class="body_content">
    <app-motor-header [user]="user$ | async" />
    <router-outlet />
    <app-loading />
  </div>
  <app-footer />
</div>